export default __webpack_public_path__ + "static/media/img-slider-lh-career-2.9756c8ff.png";